<template>
  <div id="login123" style="background: url(static/login.jpg)">
    <div id="tou-wrap">
      <h3 style="margin: 10px auto 0px auto; text-align: center; color: #fff">
        {{ lycsr.title }}
      </h3>
    </div>
    <div id="loginForm">
      <Form ref="item" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="用户名">
              <Input
                v-model="loginMsg.username"
                placeholder="请输入用户名"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="登录密码">
              <Input
                v-model="loginMsg.password"
                type="password"
                password
                placeholder="请输入密码"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="btn-wrap123">
        <Button type="primary" long :loading="loading" @click="login">
          <span v-if="!loading">立即登录</span>
          <span v-else>登录中...</span>
        </Button>
        <Checkbox style="margin-top: 20px" v-model="storagePasspord"
          >记住用户名和密码</Checkbox
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: false,
      loginMsg: {
        username: "",
        password: "",
      },
      storagePasspord: false,
    };
  },
  created() {
    //this.dddd();
  },
  methods: {
    login() {
      if (this.loginMsg.password.length < 6) {
        this.$Message.error("密码不足6位");
        return;
      }
      this.loading = true;
      let params = {
        loginName: this.loginMsg.username,
        password: this.loginMsg.password,
      };
      axios({
        method: "post",
        url: axios.serverWeb + "/auth/login",
        data: params,
      }).then((response) => {
        var data = response.data;
        this.loading = false;
        var myData = response.data;
        if (myData.code == 200) {
          var obj = {
            token: myData.data.token,
            identityId: myData.data.identityId,
            share: myData.data.share,
          };
          // console.log(obj);
          localStorage.setItem("phone", JSON.stringify(obj));
          if (this.storagePasspord) {
            localStorage.setItem("phoneLogin", JSON.stringify(this.loginMsg));
          } else {
            localStorage.removeItem("phoneLogin");
          }
          this.$router.push({
            path: "/home",
          });
        } else {
          this.$Message.error(myData.message);
        }
      });
    },
  },
  mounted() {
    var msyy = JSON.parse(localStorage.getItem("phoneLogin"));
    if (msyy != null) {
      this.loginMsg = msyy;
      this.storagePasspord = true;
    }
  },
};
</script>
<style lang="">
#login123 {
  background: #fff;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  overflow: hidden;
}
#loginForm {
  background: #fff;
  width: 92%;
  padding: 20px;
  margin: 0px auto;
  border-radius: 0px 0px 6px 6px;
}
#loginForm .btn-wrap {
  width: 92%;
  margin: 0px auto;
  border-radius: 0px 0px 6px 6px;
}
#tou-wrap {
  width: 92%;
  margin: 50px auto 0 auto;
  background: #2272ce;
  padding: 20px 0 20px 0;
  border-radius: 6px 6px 0px 0px;
}
#tou {
  width: 70px;
  margin: 0px auto;
  display: block;
}

#beian {
  position: absolute;
  bottom: 20px;
  left: 0;
  text-align: center;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue